import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from "react-router-dom";
import { deleteBanner, getBanner, updateBanner } from "../../../api/banner.api";
import useAxios from "../../../hooks/useAxios";
import { IGetBanner } from "../../../models/banner.model";
import Editor from "../../../components/homepage/top-banner/Editor";
import Loader from "../../../components/Loader";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import useNotification from "../../../hooks/useNotification";

interface IMatch {
  bannerCode: string;
}

const TopBannerEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const bannerCode = Number(match.params.bannerCode);
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetBanner>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios();
  
  useEffect(() => {
    execute(getBanner(bannerCode));
  }, []);

  useEffect(() => {
    if (res2 && !isLoading2) {
      successNotification(t('common.message.edit1'));
      history.push('/homepage/top-banner');
    }
  }, [res2, isLoading2]);

  useEffect(() => {
    if (res3 && !isLoading3) {
      successNotification(t('common.message.delete'));
      history.push('/homepage/top-banner');
    }
  }, [res3, isLoading3]);

  const submit = (data: FormData) => {
    execute2(updateBanner(bannerCode, data));
  }

  const remove = () => {
    execute3(deleteBanner(bannerCode));
  }

  return (
    <div className="content scrollbar">
      {isLoading || isLoading2 || isLoading3 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.topBanner.title4')}
      />

      <Editor
        data={res?.data}
        submit={submit}
        remove={remove}
      />
    </div>
  );
}

export default TopBannerEdit;
